// extracted by mini-css-extract-plugin
module.exports = {"root":"sharps-disposal-page_root__rJTbN"};